import { api } from './api';

export interface BrandCraftInput {
  brandName: string;
  tagline: string;
  description: string;
  primaryColor: string;
  secondaryColor: string;
  accentColor: string;
  fontHeading: string;
  fontBody: string;
  style?: string;
}

export interface LogoVariation {
  id: string;
  url: string;
  filename: string;
  style: string;
}

export interface BrandMockup {
  id: string;
  url: string;
  templateName: string;
  filename: string;
}

export const brandCraftService = {
  async generateLogos(input: BrandCraftInput): Promise<LogoVariation[]> {
    const response = await api.post<{ success: boolean; logos: LogoVariation[] }>(
      '/api/brand-craft/generate-logos',
      input
    );
    return response.data.logos;
  },

  async generateMockups(input: BrandCraftInput & { logoUrl: string }): Promise<BrandMockup[]> {
    const response = await api.post<{ success: boolean; mockups: BrandMockup[] }>(
      '/api/brand-craft/generate-mockups',
      input
    );
    return response.data.mockups;
  },

  async saveBrand(data: {
    brandName: string;
    tagline: string;
    primaryColor: string;
    secondaryColor: string;
    accentColor: string;
    logoUrl: string;
  }): Promise<void> {
    await api.post('/api/brand-craft/save', data);
  },
};
